// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Auth usa localStorage (padrão do Supabase JS).
// sessionStorage foi removido pois quebra o fluxo PKCE de reset de senha:
// o pkce_code_verifier gerado na aba A não existe na aba B (nova aba aberta pelo link
// do email), fazendo exchangeCodeForSession() falhar com "invalid code verifier".
// localStorage é compartilhado entre abas do mesmo domínio, resolvendo o problema.
// A diferença de segurança vs sessionStorage é irrelevante: ambos são acessíveis por XSS.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});